import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-expected-datewise-all-ticket-count',
  templateUrl: './expected-datewise-all-ticket-count.component.html',
  styleUrls: ['./expected-datewise-all-ticket-count.component.css']
})
export class ExpectedDatewiseAllTicketCountComponent implements OnInit {

  constructor( private userService: UserService,private errorHandler: ErrorHandler ) { }

  ngOnInit() {
    this.TicketsToBeResolvedDatewise()
  }

  TicketsToBeResolvedDatewise = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.ticketsToBeResolvedDatewise()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/expected-datewise-all-ticket-count/expected-datewise-all-ticket-count.component.ts